import Vue from 'vue';
import VueRouter from 'vue-router';
import VueGtag from 'vue-gtag';
import App from './App.vue';
import './index.css';
import router from './router';
import store from './store/index';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import VueMixpanel from './plugins/mixpanel';
import { config } from './config';

Vue.use(VueRouter);
Vue.use(VueGtag, {
	config: {
		id: process.env.VUE_APP_NODE_ENV === 'production' ? 'G-CC4GN7KLT6' : 'G-Y4LFNLW8ED',
		params: {
			send_page_view: false,
			first_visit: false,
			scroll: false,
			session_start: false
		}
	}
});

// log to mixpanel
Vue.use(VueMixpanel, {
	token: process.env.VUE_APP_NODE_ENV === 'production' && !config.is_mixpanel_enabled
		? process.env.VUE_APP_MIX_PANEL_KEY
		: 'e1b9e5dd4ac6691cb595772d402c7b1e'
});

Vue.config.productionTip = false;

const env = ['staging', 'production'];
if (!env.includes(process.env.VUE_APP_NODE_ENV)) {
	Bugsnag.start({
		apiKey: process.env.VUE_APP_BUGSNAG_KEY,
		plugins: [new BugsnagPluginVue()],
		appType: 'klump_checkout',
		enabledReleaseStages: ['production', 'staging'],
		releaseStage: process.env.VUE_APP_NODE_ENV,
		redactedKeys: [
			'token', // exact match: "access_token"
			/^password$/i, // case-insensitive: "password", "PASSWORD", "PaSsWoRd"
			/^cc_/ // prefix match: "cc_number" "cc_cvv" "cc_expiry"
		]
	});

	Bugsnag.getPlugin('vue').installVueErrorHandler(Vue);
}


Vue.filter('formatCurrency', (val, currency = 'NGN') => {
	let country;
	if (currency === 'NGN') {
		country = 'NG';
	} else if (currency === 'GHS') {
		country = 'GH';
	} else if (currency === 'USD') {
		country = 'US';
	}
	const formatter = new Intl.NumberFormat(`en-${country}`, {
		style: 'currency',
		currency,
		minimumFractionDigits: 2
	});

	return formatter.format(val);
});


new Vue({
	router,
	store,
	data() {
		return {
			isSuccessful: false,
			isClosed: false,
			isFailed: false
		};
	},
	computed: {
		isUserOnline() {
			return store.getters.getUserOnlineStatus;
		}
	},
	watch: {
		isUserOnline() {
			window.addEventListener('online', this.handleIsUserOnline);
			window.addEventListener('offline', this.handleIsUserOnline);
		}
	},
	mounted() {
		window.addEventListener('online', this.handleIsUserOnline);
		window.addEventListener('offline', this.handleIsUserOnline);
	},
	created() {
		window.addEventListener('message', this.flutterwaveEventHandler, false);
	},
	methods: {
		/**
		* Handles user's network status
		*/
		handleIsUserOnline(event) {
			const { type } = event;
			const status = type === 'online';
			if (status) {
				store.commit('setUserOnlineStatus', true);
				store.commit('setAlert', {
					type: 'success',
					message: 'Welcome back online'
				});
			} else {
				store.commit('setUserOnlineStatus', false);
				store.commit('setAlert', {
					type: 'danger',
					message: 'You are currently offline, please restore internet connection before continuing.'
				});
			}
		},
		flutterwaveEventHandler(event) {
			if (!store.getters.getFlutterwaveIframeListener) {
				return;
			}
			/**
			 * listening for events from flutterwave handler iframe
			 */
			let parsedData = { type: '' };
			let data;
			if (event && event.data) {
				data = event.data;
				// This is for paystack which returns different checkout lifecycle events ('loaded:checkout' and 'loaded:transaction' and 'success')
				// we return the request, if it is true because it is not a JSON, therefore not parse-able
				// For 'success', we also return
				// because we want klump redirect_url handler code to handle the success message displayed to merchant and also passed to merchant site
				if (data === 'loaded:checkout' || data === 'loaded:transaction' || data.event === 'loaded:checkout' || data.event === 'loaded:transaction' || data.event === 'success') {
					return;
				}
				parsedData = JSON.parse(data);
			}
			if (parsedData.type === 'SUCCESS' && !this.isSuccessful) {
				store.commit('setIframeResponseOnLoad', {
					status: false,
					type: 'LOADING'
				});
				store.commit('setIframeResponseOnSuccess', {
					data: parsedData.data,
					type: 'SUCCESS'
				});
				this.isSuccessful = true;
				return;
			}
			if (parsedData.type === 'ERROR' && !this.isFailed) {
				store.commit('setIframeResponseOnLoad', {
					status: false,
					type: 'LOADING'
				});
				store.commit('setIframeResponseOnError', {
					data,
					type: 'ERROR'
				});
				this.isFailed = true;
				return;
			}
			if (parsedData.type === 'CLOSE' && !this.isClosed) {
				window.parent.postMessage(
					JSON.stringify({
						data: {
							status: false,
							type: 'LOADING'
						}
					}),
					'*'
				);
				window.parent.postMessage(
					JSON.stringify({
						data: {
							status: true,
							type: 'CLOSE'
						}
					}),
					'*'
				);
				this.isClosed = true;
				return;
			}
		}
	},
	render: (h) => h(App)
}).$mount('#app');
